import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ValidatorFn } from '@angular/forms';
import { PrimaryTravelerDetailComponent } from './../traveler/primary-traveler-detail.component';
import { Traveler } from './../../shared';

@Component({
    selector: 'policy-buyer',
    template: require('./policy-buyer.component.html')
})
export class PolicyBuyerComponent extends PrimaryTravelerDetailComponent implements OnChanges {
    @Input() public postalCodeError: string;
    
    public get shouldDisplayForm(): boolean {
        return this.form && this.configuration && this.traveler && this.formInitialized;
    }

    constructor(formBuilder: FormBuilder) {
        super(formBuilder);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.form && this.traveler && this.configuration && !this.formInitialized) {
            this.buildForm();
        }
        else if (!this.traveler && this.formInitialized) {
            this.tearDownForm();
        }
    }

    protected buildForm(): void {
        if (this.traveler) {
            this.buildFirstNameControl();
            this.buildLastNameControl();
            this.buildBirthDateControl();
            this.buildEmailControl();
            this.buildPhoneNumberControl();
            this.buildAddressFormGroup();
        }

        this.formInitialized = true;
    }

    protected tearDownForm(): void {
        this.formInitialized = false;
        this.form.removeControl('firstName');
        this.form.removeControl('lastName');
        this.form.removeControl('birthDate');
        this.form.removeControl('emailGroup');
        this.form.removeControl('phoneNumber');
        this.form.removeControl('address');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/policy-buyer/policy-buyer.component.ts